module.exports = __webpack_public_path__ + "img/LATAM_FISH.0c0bde76.png";